const nameMap = {
    phoneNum: '行動電話號碼',
    name: '姓名',
    username:'姓名',
    email: '電子郵件信箱',
    referrer_phoneNum: '推薦人電話',
    notification_type: '接收通知方式',
    gender: '性別',
    height: '身高',
    weight: '體重'
}

export default nameMap;


/** WEBPACK FOOTER **
 ** ./src/config/nameMap.js
 **/